module.exports = __webpack_public_path__ + "img/in-progress-survey.f1df6933.png";